import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export { type ColorScheme }

export const SIDE_NAV_WIDTH_OPEN = '240px'
export const SIDE_NAV_WIDTH_CLOSED = '60px'

// ─── Container ───────────────────────────────────────────────────────────────

const containerTokens = {
  dark: { bg: 'bg.sidebar' },
  light: { bg: 'light.bg.sidebar' },
} as const

export const sideNavContainerStyles = (
  isOpen: boolean,
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  top: 0,
  left: 0,
  width: isOpen ? SIDE_NAV_WIDTH_OPEN : SIDE_NAV_WIDTH_CLOSED,
  bg: containerTokens[colorScheme].bg,
  transition: 'ease-in-out 0.3s width',
  zIndex: 100,
  minH: 0,
})

// ─── Nav Item ─────────────────────────────────────────────────────────────────

const tokens = {
  dark: {
    activeBarColor: 'interactive.nav-active',
    activeBg: 'bg.sidebar-active',
    hoverBg: 'bg.sidebar-hover',
    iconActive: 'text.nav-active',
    iconDefault: 'icon.secondary',
    textDefault: 'text.nav-default',
  },
  light: {
    activeBarColor: 'light.interactive.nav-active',
    activeBg: 'light.bg.sidebar-active',
    hoverBg: 'light.bg.sidebar-hover',
    iconActive: 'light.text.nav-active',
    iconDefault: 'icon.secondary',
    textDefault: 'light.text.nav-default',
  },
} as const

export const sideNavItemWrapperStyles = (
  isActive: boolean,
  isExpanded: boolean,
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'ease-in-out 0.3s width',
  width: isExpanded ? SIDE_NAV_WIDTH_OPEN : SIDE_NAV_WIDTH_CLOSED,
  bg: isActive ? tokens[colorScheme].activeBg : 'transparent',
  _hover: { bg: tokens[colorScheme].hoverBg },
})

export const sideNavIconStyles = (
  isActive: boolean,
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  color: isActive
    ? tokens[colorScheme].iconActive
    : tokens[colorScheme].iconDefault,
  transition: '0.3s',
})

export const sideNavLabelStyles = (
  isActive: boolean,
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  color: isActive
    ? tokens[colorScheme].iconActive
    : tokens[colorScheme].textDefault,
  textStyle: 'body-large',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})
